export default __webpack_public_path__ + "static/media/AM Joias.fd2844f5.png";